module.exports = __webpack_public_path__ + "static/media/email-not-found.cc59a00d.svg";